import React from 'react';
import './MapPage.css';

const MapPage = () => {
  return (
    <div className="map-page">
      <h2 className="map-title">GETTING THERE</h2>
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps?q=The+British+Academy,10-11+Carlton+House+Terrace,St.+James's,London+SW1Y+5AH,UK&output=embed&z=15"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="The British Academy Location"
        ></iframe>
      </div>
    </div>
  );
};

export default MapPage;
